import React from 'react';
import { withStyles } from 'tss-react/mui';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import ApiService from '../../../common/services/ApiService';
import MetadataService from '../../../common/services/MetadataService';
import AdminTable from '../../../common/components/table/AdminTable';
import AdminModal from '../../../common/components/modal/AdminModal';
import ProfilingToolLabelForm from '../../../common/components/modal/ProfilingToolLabelForm';
import WaveTextField from '../../../common/components/form/WaveTextField';

const styles = theme => ({
  container: {
    padding: theme.typography.pxToRem(25),
    paddingTop: theme.typography.pxToRem(22)
  },
  header: {
    paddingBottom: theme.typography.pxToRem(12)
  },
  profilingToolLabelsHeader: {
    padding: `${theme.typography.pxToRem(22)} ${theme.typography.pxToRem(
      25
    )} ${theme.typography.pxToRem(25)} ${theme.typography.pxToRem(25)}`
  }
});

class Profiling extends React.Component {
  constructor(props) {
    super(props);
    this.api = new ApiService();
    this.meta = new MetadataService();
    this.state = {
      id: null,
      mode: null,
      open: false,
      refreshTick: 0
    };
  }

  forceRefresh = () => {
    this.setState({ refreshTick: Date.now() });
  };

  handleCloseModal = () => {
    this.setState({ mode: null, open: false, id: null });
  };

  handleOpenEditModal = row => {
    this.setState({ mode: 'edit', open: true, id: row.id });
  };

  handleInputChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    let institute = { ...this.props.instituteDetails };
    institute[name] = value;

    this.props.onChange(institute);
  };

  errorHelpers = (field) => {
    if (this.props.validationErrors.hasOwnProperty(field)) {
      return this.props.validationErrors[field][0];
    }
    return null;
  };

  errorStatus = (field) => {
    return this.props.validationErrors.hasOwnProperty(field);
  };

  makeFieldProps = (field) => {
    return {
      error: this.errorStatus(field),
      helperText: this.errorHelpers(field),
      name: field,
      onChange: this.handleInputChange,
      value: this.props.instituteDetails[field]
    };
  };

  render() {
    const { classes } = this.props;
    const { id, mode, open } = this.state;
    const fields = ['text', 'value'];
    const actions = ['edit'];

    return (
      <Grid container spacing={2}>
        <Grid size={12}>
          <Paper className={classes.container}>
            <Typography className={classes.header} variant="h6">
              Dashboard
            </Typography>
            <Grid container spacing={4}>
              <Grid size={{xs:12, md:6}}>
                <WaveTextField
                  label="Warning Days"
                  {...this.makeFieldProps('profiling_warning_days')}
                />
              </Grid>
              <Grid size={{xs:12, md:6}}>
                <WaveTextField
                  label="Overdue Days"
                  {...this.makeFieldProps('profiling_overdue_days')}
                />
              </Grid>
            </Grid>
          </Paper>
        </Grid>
        <Grid size={12}>
          <Paper>
            <Grid container className={classes.profilingToolLabelsHeader}>
              <Typography variant="h6">
                Profiling Tool Response Labels
              </Typography>
            </Grid>
            <AdminTable
              tableBottomPadding
              actionsSection={actions}
              fields={fields}
              onOpenEditModal={this.handleOpenEditModal}
              refreshTick={this.state.refreshTick}
              resource="response_labels"
            />
          </Paper>
        </Grid>
        <AdminModal
          component={ProfilingToolLabelForm}
          fields={fields}
          id={id}
          mode={mode}
          onCloseModal={this.handleCloseModal}
          onForceRefresh={this.forceRefresh}
          open={open}
          resource="response_labels"
          title="Label"
        />
      </Grid>
    );
  }
}

export default withStyles(Profiling, styles, { withTheme: true });
